import IMask from 'imask';

/**
 * Helper to extract input element from component or native wrapper
 */
function getInput(el) {
  return el.tagName === 'INPUT' ? el : el.querySelector('input');
}

/**
 * Emit input event to both Vue component instance (v-model) and DOM
 */
function emitValue(input, vnode, value) {
  if (vnode && vnode.componentInstance) {
    vnode.componentInstance.$emit('input', value);
  }
  input.dispatchEvent(new Event('input', { bubbles: true }));
}

/**
 * Vue 2 Directive: v-date-mask
 * Formats date inputs as DD.MM.YYYY and syncs with Vue v-model & bootstrap datetimepicker
 */
export default {
  bind(el, binding, vnode) {
    const input = getInput(el);
    if (!input) return;

    const maskOptions = binding.value || { mask: '00.00.0000' };
    const mask = IMask(input, maskOptions);
    input._imask = mask;

    if (input.value) {
      mask.value = input.value;
    }

    mask.on('accept', () => {
      if (mask.value.length === 10 || mask.value.length === 0) {
        emitValue(input, vnode, mask.value);
        if (window.$) {
          window.$(input).trigger('change');
        }
      }
    });

    input._blurHandler = () => {
      emitValue(input, vnode, mask.value);
    };
    input.addEventListener('blur', input._blurHandler);

    if (window.$) {
      window.$(input).on('dp.change.vDateMask', (e) => {
        if (input._imask) {
          if (e.date) {
            const formatted = e.date.format('DD.MM.YYYY');
            if (input._imask.value !== formatted) {
              input._imask.value = formatted;
            }
          } else if (!input.value) {
            input._imask.value = '';
          }
        }
      });
    }
  },

  inserted(el) {
    const input = getInput(el);
    if (input && input._imask && input.value && !input._imask.value) {
      input._imask.value = input.value;
    }
  },

  componentUpdated(el, binding, vnode) {
    const input = getInput(el);
    if (!input || !input._imask) return;

    const currentValue = input.value;
    if (currentValue && input._imask.value !== currentValue) {
      input._imask.value = currentValue;
    }
  },

  unbind(el) {
    const input = getInput(el);
    if (!input) return;

    if (input._blurHandler) {
      input.removeEventListener('blur', input._blurHandler);
      delete input._blurHandler;
    }

    if (window.$) {
      window.$(input).off('.vDateMask');
    }

    if (input._imask) {
      input._imask.destroy();
      delete input._imask;
    }
  },
};
